"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteMinutes = void 0;
function deleteMinutes(utils) {
    var a11yHasExpectedHtml = utils.a11yHasExpectedHtml, hasReturnVal = utils.hasReturnVal, loadPrimaryInput = utils.loadPrimaryInput, use = utils.use;
    describe('Minutes - Delete', function () {
        it('Should clear minutes on delete key press', function () {
            loadPrimaryInput({ segment: 'minutes' })
                .then(use.del)
                .should('have.value', '08:-- PM')
                .then(a11yHasExpectedHtml("<p>blank.</p>"))
                .then(hasReturnVal(''));
        });
        it('Should clear minutes on backspace key press', function () {
            loadPrimaryInput({ segment: 'minutes' })
                .then(use.backspace)
                .should('have.value', '08:-- PM')
                .then(a11yHasExpectedHtml("<p>blank.</p>"))
                .then(hasReturnVal(''));
        });
    });
}
exports.deleteMinutes = deleteMinutes;
